export * from "./PFFContentSection";
export * from "./PFFFurtherReading";
export * from "./PFFMetrics";

export const PFF_CONTENT_OFFSET = [50, 100, 200, 100, 50];
